import { render, staticRenderFns } from "./wrongQuestion.vue?vue&type=template&id=ebd44de0&scoped=true"
import script from "./wrongQuestion.vue?vue&type=script&lang=js"
export * from "./wrongQuestion.vue?vue&type=script&lang=js"
import style0 from "./wrongQuestion.vue?vue&type=style&index=0&id=ebd44de0&prod&lang=scss"
import style1 from "./wrongQuestion.vue?vue&type=style&index=1&id=ebd44de0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd44de0",
  null
  
)

export default component.exports